module.exports = __webpack_public_path__ + "static/ladies-86466d1613538c38d2b4cdfbc96d0612.jpg";